import { PagedRequest } from "@app/common/models/paged-request";
import { PagedResult } from "@app/common/models/paged-result";
import { SearchItem } from "./search-item";

export class SearchState {
    clickedItemIndex: number;
    pagedResults: PagedResult<SearchItem> = new PagedResult<SearchItem>();
    pagedRequest: PagedRequest<SearchItem> = new PagedRequest<SearchItem>();
}